// Pages synced from claimify-front read the signed-in user's agency from
// localStorage ("agency"), often when their module first loads. zamchema serves
// a single agency, so make sure one is always there: the login response doesn't
// include it for the agency account itself, and sessions started before the
// design-system sync never stored it. Imported first in main.js.
export const ZAMCHEMA_AGENCY = {
  id: 4,
  state: 2683,
  firstname: "ZAMCHEMA",
  agency_name: "Zamfara State Contributory Healthcare Management Agency",
  user_image: "",
};

export function ensureAgency(agency) {
  let stored = agency;
  if (stored === undefined) {
    try {
      stored = JSON.parse(localStorage.getItem("agency") || "null");
    } catch (e) {
      stored = null;
    }
  }
  if (!stored || !stored.id) stored = ZAMCHEMA_AGENCY;
  localStorage.setItem("agency", JSON.stringify(stored));
  return stored;
}

ensureAgency();
